import React from "react";
import LineCrudTableRow from "./LineCrudTableRow";
import C from "helpers/HelpConstants";
import {HelpAbility} from "helpers/HelpAbility";
import ReactPaginate from "react-paginate";
import { ITEMS_BY_PAGE_OPTIONS } from "constants/pagination";

const LineCrudTable = ({
        lines,
        editData,
        deleteData,
        listLines,
        handleShow,
        setFindModal,
        listClientsByNumberLine,
        listClientsAll,
        setIdforLine,
        amountPages,
        itemsPerPage,
        setItemsPerPage,
        resetSearch,
        hasSearched,
    }) => {
    let myAbilities = HelpAbility();

    const handlePageClick = async (data) => {
        listLines(data.selected + 1);
    };

    const resetList = async () => {
        listLines(1);
        resetSearch();
    };

    const onItemsPerPageChange = (e) => {
        const newItemsPerPage = e.target.value;
        setItemsPerPage(newItemsPerPage);
        listLines(1, newItemsPerPage)
    }

    return (
        <div className="mt-4">
            <div className="row mb-2">
                <div className="col d-flex align-items-end">
                    <h6>Líneas Registradas</h6>
                </div>
                <div className="col d-flex justify-content-end"> 
                    <div className="d-flex flex-row gap-3">
                    <div className="col d-flex flex-row align-items-center gap-2">
                        <label htmlFor="items-by-page" className="form-label mb-0">Mostrar: </label>
                        <select onChange={onItemsPerPageChange} disabled={hasSearched} className="form-select form-select-sm" aria-label="Default select example" name="items-by-page" style={{width: '70px'}} value={itemsPerPage}>
                        {
                            ITEMS_BY_PAGE_OPTIONS.map((value) => (
                                <option value={value} key={'item-by-page-option-' + value}>{value}</option>                
                            ))
                        }            
                        </select>
                    </div>
                    <button type="submit" className="btn btn-primary" onClick={resetList} disabled={!hasSearched}>Limpiar búsqueda</button>
                    </div>
                </div>
            </div>
            <div className="table-responsive rounded-3" style={{border: '1px solid black'}}>
                <table className="table">
                    <thead>
                    <tr>
                        <th scope="col" className="text-center">#</th>
                        <th scope="col" className="text-center">Número de Línea</th>
                        <th scope="col" className="text-center">Tipo de Línea</th>
                        <th scope="col" className="text-center">Número de Reportes</th>
                        <th scope="col" className="text-center">Primer Reporte</th>
                        <th scope="col" className="text-center">Último Reporte</th>
                        <th scope="col" className="text-center">Número de Documento Asociado</th>
                        {myAbilities.hasAny([C.A.LINE.UPDATE, C.A.LINE.LINK, C.A.LINE.DELETE]) &&
                        <th scope="col" className="text-center">Acción</th>}
                    </tr>
                    </thead>
                    <tbody>
                    {
                        lines.length > 0 ? lines.map((el, i) => <LineCrudTableRow
                                key={el._id}
                                el={el}
                                i={i}
                                editData={editData}
                                deleteData={deleteData}
                                handleShow={handleShow}
                                listClientsAll={listClientsAll}
                                setFindModal={setFindModal}
                                listClientsByNumberLine={listClientsByNumberLine}
                                setIdforLine={setIdforLine}/>) :
                            <tr>
                                <td colSpan="5">Sin datos</td>
                            </tr>
                    }
                    </tbody>
                </table>
            </div>
            <div>
                {
                    !hasSearched ? 
                    <ReactPaginate
                        previousLabel={"Anterior"}
                        nextLabel={"Siguiente"}
                        breakLabel={"..."}
                        pageCount={amountPages}
                        //Cuantas paginas quieres mostrar despues d elos 3 ...
                        marginPagesDisplayed={1}
                        //En cada pagina tiene dos lados, uno izquierda y otro derecha, cuantas n paginas quieres en eso dos lados, excepto para la primera y ultima pagina que para estos cubriran n paginas pero para su dirección de ida o retorno de lado respectivamente
                        pageRangeDisplayed={2}
                        onPageChange={handlePageClick}
                        containerClassName={"pagination justify-content-center mt-3"}
                        pageClassName={"page-item"}
                        pageLinkClassName={"page-link"}
                        previousClassName={"page-item"}
                        previousLinkClassName={"page-link"}
                        nextClassName={"page-item"}
                        nextLinkClassName={"page-link"}
                        breakClassName={"page-item"}
                        breakLinkClassName={"page-link"}
                        activeClassName={"active"}
                    />
                    : null
                }
            </div>
        </div>
    );
}
export default LineCrudTable;
